export default function formatReleaseLine(
  release: Partial<
    Omit<API.Release, 'rotation'> & { rotation?: API.Release['rotation'] | string | number }
  >,
  useShort = false,
  hideDefaultPrice = true,
) {
  const { rotation = '0', visitor = {}, home = {}, period, price = -110 } = release;
  const { playText, playType, totalIndicator, total, sideIndicator, side } = release;
  const p = period == 1 ? '1H' : period == 2 ? '2H' : '';
  let s = `${side}`;

  if (side === 0) {
    s = 'PK';
  } else if (side && side > 0) {
    s = `+${side}`;
  }

  const name = useShort
    ? (where: Record<string, string>) => where?.shortName || where?.name || ''
    : (where: Record<string, string>) => where?.name || '';
  const priceTxt = hideDefaultPrice && price === -110 ? '' : `(${price > 0 ? '+' : ''}${price})`;

  const hname = name(home);
  const vname = name(visitor);

  if (playType === 'prop' || playType === 'future') {
    return `${playText} ${priceTxt}`.replace(/ +/g, ' ');
  } else if (playType === 'not-available') {
    return 'Not available';
  } else if (sideIndicator === 'home') {
    return `${rotation || ''} ${hname} ${s} ${priceTxt} ${p} ${vname ? 'vs. ' : ''}${vname}`
      .replace(/ +/g, ' ')
      .trim();
  } else if (sideIndicator === 'visitor') {
    return `${rotation || ''} ${vname} ${s} ${priceTxt} ${p} ${hname ? 'at ' : ''}${hname}`
      .replace(/ +/g, ' ')
      .trim();
  } else if (totalIndicator === 'over') {
    return `${rotation || ''} ${vname}${hname && vname ? '/' : ''}${hname} ${hname ? 'Over' : 'O'} ${total} ${p} ${priceTxt}`
      .replace(/ +/g, ' ')
      .trim();
  } else if (totalIndicator === 'under') {
    return `${rotation || ''} ${vname}${hname && vname ? '/' : ''}${hname} ${hname ? 'Under' : 'U'} ${total} ${p} ${priceTxt}`
      .replace(/ +/g, ' ')
      .trim();
  } else {
    return 'Whoops';
  }
}
